import { getZeroSalesColumns, getZeroSalesRows } from "./zero-sales-statement";
import { getZeroRatedSales } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";

export default function ReportZeroRatedSales({ activeCompany }) {
  return (
    <DynamicReport
      reportName="zero-rate-sale"
      activeCompany={activeCompany}
      columnsDataProvider={getZeroSalesColumns}
      rowsDataProvider={getZeroSalesRows}
      fetchData={getZeroRatedSales}
      exportUrl="reports/export-query-report/zero-rate-sale"
      filtersInitialState={{}}
      orderBy="InvoiceNumber"
    />
  );
}
